import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { SquaresFour } from '@phosphor-icons/react';
import Avatar from '../../Utility/Avatar';
import { setSelectedPrompt } from '../../../Store/Actions/environmentActions';
import { setMobileMenuOpen } from '../../../Store/Actions/navigationHeaderActions';
import { ChatMessageRole } from '../../../Types/Enums';

export default function AssistentList() {
    const i18n = useSelector((state: any) => state.i18n.i18n);
    const combinedPrompts = useSelector((state: any) => state.environment.combinedPrompts);
    const navigate = useNavigate();
    const dispatch = useDispatch();

    return (
        <>
            <div className="h-fit w-full flex flex-col gap-2">
                {combinedPrompts && combinedPrompts.map((prompt: any) => (
                    <button
                        className={`relative gap-2 rounded-xl min-h-[45px] py-1 px-0 px-2 bg-transparent hover:bg-chatlist-item-background-hover grow hover:cursor-pointer flex items-center h-fit w-full`}
                        onClick={() => {
                            dispatch(setMobileMenuOpen(false));
                            dispatch(setSelectedPrompt(prompt.identifier));
                            navigate(`/start/${prompt.identifier}`);
                        }}
                        key={prompt.identifier}
                    >
                        <Avatar
                            role={ChatMessageRole.assistant}
                            avatarImage={prompt.image}
                            title={prompt.name}
                            size={32}
                            position="relative"
                        />
                        <p className={`m-0 p-0 max-w-full truncate`}>{prompt.name}</p>
                    </button>
                ))}

                <button
                    className={`relative !no-underline gap-2 rounded-xl h-[50px] py-1 px-0 px-2 bg-transparent hover:bg-chatlist-item-background-hover grow hover:cursor-pointer flex items-center h-fit w-full`}
                    onClick={() => {
                        dispatch(setMobileMenuOpen(false));
                        navigate(`/userassistants`);
                    }}
                >
                    <span className="text-chatlist-allAssistant-text bg-chatlist-allAssistant-background flex justify-center items-center p-0 p-1 h-[32px] w-[32px] rounded-full">
                        <SquaresFour size={20} />
                    </span>
                    <span className="text-layout-textcolor">
                        {i18n.translate({ id: 'chatlist.allAssistants', sourceName: 'Main' })}
                    </span>
                </button>
            </div>
        </>
    );
}
